import { put, take, call, fork } from "redux-saga/effects";
import {
  disableScopeLoading,
  enableScopeLoading,
} from "../scope-loading/actions";
import { ClaimAction, ClaimScope } from "./types";
import { ScopeErrorAction } from "../scope-error/types";
import * as Api from "../../service/api";
import { navigateTo } from "../../helper";
import RouteNames from "../../routes/type";
import axios from "axios";
import { uploadInvoiceFailure, uploadInvoiceSuccess } from "./actions";
import { getUniqueId, setCookie, getCookie } from "../../helper";

function* uploadInvoiceFlow() {
  while (true) {
    const action = yield take(ClaimAction.UPLOAD_INVOICE_REQUEST);
    const file = action.payload;
    yield put(enableScopeLoading(ClaimScope));
    try {
      const uniqueId = getUniqueId();
      // @ts-ignore
      const { uploadUrl, publicUrl } = yield call(
        Api.deskTicket.getPreSignedURL,
        file.type
      );

      yield call(axios.put, uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      const result = { url: publicUrl, uniqueId };
      yield put(uploadInvoiceSuccess(result));

      // Update the main claim_data cookie with uploaded invoice URL
      const existingData = getCookie("ace2_claim_data");
      let claimData = existingData ? JSON.parse(existingData) : {};

      // Merge uploaded invoice URL into purchase_info
      claimData = {
        ...claimData,
        unique_id: uniqueId,
        purchase_info: {
          ...claimData.purchase_info,
          uploaded_invoice_url: publicUrl,
        },
      };

      setCookie("ace2_claim_data", JSON.stringify(claimData), 1);
    } catch (error: any) {
      console.error("❌ Upload failed:", error);
      yield put(uploadInvoiceFailure(error?.message || "Upload Failed"));
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}

function* submitClaimFlow() {
  while (true) {
    const request = yield take(ClaimAction.SUBMIT_CLAIM);
    yield put(enableScopeLoading(ClaimScope));
    try {
      const contact_email =
        request?.payload?.customer_info?.email || "no@email.com";
      const data = yield call(Api.deskTicket.claimTicket, {
        contact_email,
        data: request.payload,
      });
      yield navigateTo(
        `${RouteNames.CREATE_CLAIM}?step=6&ticket=${data?.ticketNumber}`
      );
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}
export default function* userSaga() {
  yield fork(submitClaimFlow);
  yield fork(uploadInvoiceFlow);
}
